import { call, put, select } from 'typed-redux-saga'

import { showError } from '@store/ui/error/actions'
import { ApplicationState } from '@store/types'
import { HttpStatus } from '@services/base'
import services from '@services'
import { BridgeService } from '@services/bridge'
import { logout } from '@utils/functions'
import { ErroType } from '@utils/types'
import { StepRefin } from '@utils/enums'

import { postValidateBiometrics } from '../actions'
import { CallbackPostValidateBiometrics } from '../types'

interface Props {
  payload: CallbackPostValidateBiometrics
  type: string
}

export default function* postValidateBiometricsSaga({ payload }: Props) {
  const { biometricToken } = yield* select((s: ApplicationState) => s.biometria)
  const { accessToken } = yield* select((s: ApplicationState) => s.session)

  try {
    const service = BridgeService.isBrowser()
      ? services.postValidateBiometricsWebService
      : services.postValidateBiometricsAppService

    yield* call(service, biometricToken, accessToken)
    yield payload.callback()
  } catch (error) {
    const erroTyped = error as ErroType

    if (BridgeService.isBrowser() && erroTyped.status === HttpStatus.UNAUTHORIZED) {
      yield put(
        showError({
          title: 'Sessão expirada',
          message: 'Efetue o login novamente.',
          actionTitle: 'Continuar',
          functionCallback: () => logout(),
        }),
      )
      return
    }

    yield put(
      showError({
        title: 'Ocorreu um erro ao validar biometria',
        message: 'Por favor tente novamente.',
        actionTitle: 'Tentar Novamente',
        code: StepRefin.ERRO_VALIDAR_BIOMETRIA,
        actionCallback: () => postValidateBiometrics(payload),
        block: true,
      }),
    )
  }
}
